import React from 'react';
import classNames from 'classnames';
import {WingBlank} from '../../components';
import './AboutLayer.less';

function AboutLayer({className, title, description='', grey=false, children, ...props}) {
  const layerProps = {
    ...props,
    className: classNames('AboutLayer', className),
    'data-mode': grey ? 'grey' : null,
    'data-description': description ? true : null
  };
  return (
    <WingBlank {...layerProps}>
      <div><i /></div>
      <h1>{title}</h1>
      {description ? <div>{description}</div> : null}
      {children}
    </WingBlank>
  );
}

export default AboutLayer;


// WEBPACK FOOTER //
// ./src/routes/About/AboutLayer.js